import { SVGAttributes } from 'react'

export default function DataIcon(attributes: SVGAttributes<SVGSVGElement>): JSX.Element {
	return (
		<svg {...attributes} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
			<path className="text-gray-800" d="M32 64c17.673 0 32-14.327 32-32C64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32z" fill="currentColor"/>
			<path className="text-gray-300" d="M43.1 38.725l-3.4 3.4c-4-4-10.6-4-14.7 0l-3.4-3.4c6-5.9 15.6-5.9 21.5 0z" fill="currentColor"/>
			<path className="text-gray-300" d="M50 31.925l-3.4 3.4c-7.8-7.8-20.5-7.8-28.3 0l-3.4-3.4c9.6-9.7 25.4-9.7 35.1 0z" fill="currentColor"/>
			<path className="text-white" d="M56.8 25.125l-3.4 3.4c-11.6-11.6-30.4-11.6-42 0l-3.4-3.4c13.5-13.5 35.3-13.5 48.8 0z" fill="currentColor"/>
			<path className="text-green-400" d="M34.7 44.125c.7.7 1 1.4.9 2.3 0 .9-.4 1.6-.9 2.2-.6.6-1.3.9-2.2.9-.9 0-1.7-.3-2.3-.9-.7-.7-1-1.4-.9-2.3 0-.9.4-1.6.9-2.2.6-.6 1.3-.9 2.2-.9.9 0 1.7.3 2.3.9z" fill="currentColor"/>
		</svg>
	)
}
